<div class="donut-container">
    <div class="donut-chart chart1" [style.background]="color2">
        <div class="slice one" [attr.style]="style1"></div>
        <div class="slice two" [attr.style]="style2"></div>
        <div class="chart-center">
            <span [style.color]="resultcolor">{{percent()}}%</span>
        </div>
    </div>
    <div class="chart-border">
    </div>
</div>